import React from 'react';
import axios from 'axios';

import Layout from '../../../components/Layout/Layout';
import Page from '../../../components/Page/Page';
import User from './User';

import { siteUrl } from '../../../config';
import { getEditStaticPage } from '../../../lib/graphql';

async function action({ locale }) {
    let dataResult = await new Promise((resolve) => {
        require.ensure([], (require) => {
            try {
                resolve(require(`./user.${locale}.md`));
            } catch (e) {
                resolve(require('./user.md'));
            }
        }, 'user');
    });

    const response = await axios.post(`${siteUrl}/graphql`, {
        query: getEditStaticPage,
        variables: { id: 2 }
    }, {
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        },
        withCredentials: true
    })
    const { data } = await response?.data;

    if (data?.getEditStaticPage?.result) {
        return {
            title: data?.getEditStaticPage?.result?.metaTitle,
            description: data?.getEditStaticPage?.result?.metaDescription,
            component: <Layout><User data={data} /></Layout>,
        };
    } else {
        return {
            title: dataResult?.title,
            component: <Layout><Page {...dataResult} containerClass="contentPageWrapper" /></Layout>,
        };
    }
}

export default action